import {HttpService} from "./http/Http.service";
import {jwtDecode} from "jwt-decode";
import {AuthBodyModel, JWTToken} from "../model/models";
import {HttpErrorService} from "./http/HttpError.service";

export class AuthService {

    static USER_TOKEN_KEY = "jwt"

    static ROLES = {
        ADMIN: 'ADMIN',
        SUPERVISOR: 'SUPERVISOR',
        STANDARD_USER: 'STANDARD_USER'
    }

    static clearSession() {
        localStorage.clear();
    }

    static async logout() {
        localStorage.removeItem(this.USER_TOKEN_KEY);
    }

    static async login(body: AuthBodyModel) {
        const response = await HttpService.getInstanceAxios().post("/auth/authenticate", body);
        const {data, headers} = response;
        const jwtToken: JWTToken = data;
        this.setToken(jwtToken);
    }

    static async getUsername() {
        try {
            const response = await HttpService.getInstanceAxios().get("/auth/me", {
                headers: {
                    Authorization: 'Bearer ' + this.getToken()
                }
            });
            return response.data;
        } catch (error) {
            HttpErrorService.handle("Errore durante il recupero dell'utente", error, true)
            return null;
        }
    }

    static getToken() {
        return localStorage.getItem(this.USER_TOKEN_KEY);
    }

    static decodeToken() {
        let token = this.getToken();
        if (token) {
            return jwtDecode(token);
        }
        return null;
    }

    static hasRole(role: string) {
        let decoded = this.decodeToken();
        if (decoded) {
            // @ts-ignore
            return decoded['roles'][0] === role;
        }
        return false;
    }

    static isAdmin() {
        return this.hasRole(this.ROLES.ADMIN)
    }

    static isSupervisor() {
        return this.hasRole(this.ROLES.SUPERVISOR)
    }

    static isStandardUser() {
        return this.hasRole(this.ROLES.STANDARD_USER)
    }

    static setToken(jwtToken: JWTToken | "") {
        if (jwtToken !== "") {
            localStorage.setItem(this.USER_TOKEN_KEY, jwtToken.id_token);
        }
    }

    static hasValidToken() {
        let decoded = this.decodeToken();
        if (!decoded)
            return false;
        if (!decoded.exp || Date.now() >= decoded.exp * 1000) {
            return false;
        }
        return true;
    }
}
